let cachedBasePath;

const normalize = (path) => {
  if (!path) {
    return '';
  }

  if (path === '/') {
    return '';
  }

  let normalized = path.trim();

  if (!normalized.startsWith('/')) {
    normalized = `/${normalized}`;
  }

  if (normalized !== '/' && normalized.endsWith('/')) {
    normalized = normalized.slice(0, -1);
  }

  return normalized;
};

const resolveDefaultBasePath = () => {
  if (typeof process === 'undefined') {
    return '';
  }

  if (process.env.REACT_APP_BASE_PATH !== undefined) {
    return process.env.REACT_APP_BASE_PATH;
  }

  if (process.env.PUBLIC_URL !== undefined) {
    return process.env.PUBLIC_URL;
  }

  return '';
};

/** Base path del build (cartella statica: /gym-2.0 su TEST). */
const BUILD_BASE_PATH = normalize(resolveDefaultBasePath());

/**
 * Su TEST Apache riscrive /gym/... → /gym-2.0/gym/... ma la barra indirizzi può restare /gym/email.
 * Il router deve usare basename '' in quel caso, altrimenti /gym-2.0 e la route non matcha → dashboard.
 */
function detectRouterBasePath() {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const pathname = window.location.pathname || '';

  if (pathname === '/gym-2.0' || pathname.startsWith('/gym-2.0/')) {
    return '/gym-2.0';
  }

  if (
    pathname === '/gym' ||
    pathname.startsWith('/gym/') ||
    pathname === '/login' ||
    pathname.startsWith('/admin') ||
    pathname.startsWith('/standalone')
  ) {
    return '';
  }

  return undefined;
}

export const getBasePath = () => {
  if (cachedBasePath !== undefined) {
    return cachedBasePath;
  }

  if (typeof window !== 'undefined') {
    if (window.__FITGYM_BASEPATH__ !== undefined) {
      cachedBasePath = normalize(window.__FITGYM_BASEPATH__);
      return cachedBasePath;
    }

    const detected = detectRouterBasePath();
    if (detected !== undefined) {
      cachedBasePath = detected;
      return cachedBasePath;
    }
  }

  cachedBasePath = BUILD_BASE_PATH;
  return cachedBasePath;
};

/** Path assoluti a JS/CSS/favicon (sempre sotto /gym-2.0 anche con URL corti /gym/...). */
export const resolveAssetPath = (relativePath = '') => {
  const base = BUILD_BASE_PATH;
  const cleanedRelative = relativePath.replace(/^\/+/, '');

  if (!base) {
    return cleanedRelative ? `/${cleanedRelative}` : '/';
  }

  return cleanedRelative ? `${base}/${cleanedRelative}` : `${base}/`;
};

export default getBasePath;
